import { AxiosInstance } from 'axios';
import { CurrentMaintenanceResponse } from 'models/api/maintenance';

const controller = '/validates'

export const checkCurrentMaintenanceStatus = async (axios: AxiosInstance) => {
  const { data } = await axios.get<CurrentMaintenanceResponse>(controller + '/maintenance/enabled');
    return data;
};
